// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__3ToGO","unreadBadge":"styles_unreadBadge__3oSZx","modalContent":"styles_modalContent__34r21","modal":"styles_modal__2G7DJ"};